import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';
import { ButtonBase } from '../../Button';
import { Heading } from '../../Heading';
import { Paragraph } from '../../Paragraph';

export const StyledButtonsContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        /* stylelint-disable unit-allowed-list */
        display: flex;
        gap: ${theme.tggSpacing(rem(2), 8)};
        justify-content: space-between;
        margin-top: ${theme.tggSpacing(rem(3), 12)};

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing([0, rem(6.4)], [0, 24])};
        }
	`}
`;

export const StyledForm = styled('form')`
    ${({ theme }: { theme: Theme }) => `
        width: 100%;

        .MuiNativeSelect-icon {
            top: ${theme.tggSpacing('auto', 'auto')};
        }

        ${theme.breakpoints.up('desktop')} {
            max-width: ${theme.tggSpacing([0, rem(41)], [0, 164])};
            margin: ${theme.tggSpacing('auto', 'auto')};
        }
	`}
`;

export const StyledSaveButton = styled(ButtonBase)`
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            padding-right: ${theme.tggSpacing(rem(3.5), 14)};
            padding-left: ${theme.tggSpacing(rem(3.5), 14)};
        }
	`}
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }) => theme.breakpoints.up('desktop')} {
        text-align: center;
    }
`;

export const StyledParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        width: 100%;

        ${theme.breakpoints.up('desktop')} {
            max-width: ${theme.tggSpacing(rem(56.8), 227)};
            margin: ${theme.tggSpacing('auto', 'auto')};
            text-align: center;
        }
	`}
`;
